import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = () => ({
  root: {
    width: '100%',
  },
});

const Header = ({
  className,
  classes,
  content,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {content}
    </Box>
  );
};

Header.defaultProps = {
  className: '',
};

Header.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  content: PropTypes.func.isRequired,
};

export default withStyles(styles)(Header);
